import { PlanTab } from '../../../../../components/verification/SubscriptionStep';
import { SubscriptionTerm } from '../../../../../services/exports/Constants';

export default {
  sections: {
    term: {
      description: 'Billed monthly. Annual is a commitment term, not a billing frequency.',
      options: {
        [SubscriptionTerm.Monthly]: 'Monthly term',
        [SubscriptionTerm.Annual]: 'Annual term',
      },
    },
    plans: {
      tabs: {
        [PlanTab.actual]: {
          name: 'Price model',
          title: 'Success-based pricing scale',
        },
        [PlanTab.legacy]: {
          name: 'Legacy',
          title: 'Plans',
        },
      },
    },
    add_ons: {
      title: 'Become a Pro with our Add ons for your Essential Plan',
      description: 'Attract new guests and drive repeat visits with these software solutions.',
    },
  },
  labels: {
    recommended: 'Recommended',
    basket: 'Basket: <strong>{{amount}}</strong> per month',
  },
  buttons: {
    review_and_subscribe: 'Review and subscribe',
    cancel: 'Cancel',
    basket: 'Back to basket',
    subscribe: 'Subscribe',
    update_subscription: 'Update subscription',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
    failed_to_save_contract: 'Failed to save the service contract',
    failed_to_create_subscription: 'Failed to create subscription',
    subscription_created: 'Subscription is successfully created',
    subscription_updated: 'Subscription is successfully updated',
  },
};
